import React from 'react';
import { EditIcon2, SaveIcon, UploadIcon2 } from '@assets/icons';
import { Button, Flex, Text } from '@chakra-ui/react';

export default function CardHeader({ isCanEdit = true, ...props }) {
    return (
        <Flex alignItems={'center'} mb={'24px'} gap={'16px'} {...props}>
            <Text fontWeight={600} fontSize={'sm'}>
                {props.title}
            </Text>
            {isCanEdit && (
                <Flex gap={'16px'} ml={'auto'}>
                    {!props.isEdit ? (
                        <Button
                            variant={'unstyled'}
                            color={'sagitarius.500'}
                            fontWeight={'700'}
                            onClick={props.handleEdit}
                            disabled={props.isDisabled}
                        >
                            <EditIcon2 /> Edit
                        </Button>
                    ) : (
                        <>
                            <Button variant={'outline'} onClick={props.handleUpload}>
                                <UploadIcon2 size={16} />
                                {props.btnLabel}
                            </Button>
                            <Button variant={'outline'} onClick={props.handleSave}>
                                <SaveIcon size={18} />
                                Simpan
                            </Button>
                        </>
                    )}
                </Flex>
            )}
        </Flex>
    );
}
